<template>
  <div id="salesExecutiveReport">

      <v-row class="mb-2 ml-0">
          <v-icon @click="$router.go(-1)" class="mr-2">mdi-arrow-left</v-icon>
          Reports <v-icon size="16" class="ml-2">mdi-greater-than</v-icon> <span class="font-weight-bold ml-2">{{$route.name}}</span>
      </v-row>

      <v-row class="justify-space-between">
          <v-col cols="auto">
              <label class="text-uppercase grey--text font-weight-bold" style="display: block; padding-left: 5px">Date</label>
              <date-range v-model="date" auto-apply appendToBody opens="right">
                  <template v-slot:input="picker" class="d-flex">
                      <v-icon class="mr-3">mdi-calendar-blank</v-icon>
                      <template>{{ picker.startDate | dateFormat }} - {{ picker.endDate | dateFormat }}</template>
                  </template>
              </date-range>
          </v-col>
          <v-col cols="3">
              <label class="text-uppercase grey--text font-weight-bold" style="display: block; padding-left: 5px">Search</label>
              <v-text-field placeholder="Search in available data..." v-model="search" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12">
              <v-btn depressed class="mr-4 ml-4 primary" @click="getSalesReport()" :disabled="disableApplyBtn">Apply</v-btn>
              <v-btn outlined @click="onClearFilter">Clear</v-btn>
              <div class="operation-div">
                  <span :style="tempShowGroupData === false?'color:#4caf50;padding-top:20px':'padding-top:20px'" @click="tempShowGroupData=false">COMPACT</span>
                  <v-switch inset v-model="tempShowGroupData" class="operation-switch pl-4" color="#cc5500"/>
                  <span :style="tempShowGroupData?'color:#cc5500;padding-top:20px':'padding-top:20px'" @click="tempShowGroupData=true">DETAIL</span>
              </div>
          </v-col>
      </v-row>

      <v-data-table :headers="headers" :items="reportData" :loading="loading"
                    :search="search" :custom-filter="filterItems" @update:page="$vuetify.goTo(0)">
          <template v-slot:no-data>No Records Available</template>
          <template v-slot:no-results>No Records Available</template>
          <template v-slot:body="{ items }">
              <tbody>
              <template v-for="(item, index) in items">                                   <!-- compact/detail view -->
                  <tr :key="index"  @click="toggleGroupRow(item)" :style="item.show?'background: #dedede':''">
                      <td>
                          <v-icon v-show="showGroupData">mdi-{{ item.show ? 'chevron-up' : 'chevron-down' }}</v-icon>
                          <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(([{path: item.profileImage, type: 'IMAGE'}]))" title="View Image">
                              <v-img v-if="item.profileImage" :src="imgWpx(item.profileImage, 200)" alt="image" @error="item.profileImage = null">
                                  <template v-slot:placeholder>
                                      <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                      <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                  </template>
                              </v-img>
                              <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                          </v-avatar>
                          <span class="c-name ellipsis" :title="item.name">{{ item.name }}<br>
                          <span :title="item.mobile" class="f-12 grey--text text--darken-1">{{item.mobile}}</span>
                          </span>
                      </td>
                      <td>{{item.aggregate.count}}</td>
                      <td>{{item.aggregate.sum.totalQty}}</td>
                      <td>{{Number(item.aggregate.sum.payableAmount) | currencyFilter}}</td>
                  </tr>
                  <tr v-for="(s, idx) in item.Customers" :key="index+'-'+idx" v-show="item.show">
                      <td style="padding-left: 50px">
                          <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;cursor: pointer" size="60" title="View Image">
                              <v-img v-if="s.profileImage" :src="imgWpx(s.profileImage, 200)" @click.stop="openGallery(([{path: s.profileImage, type: 'IMAGE'}]))" alt="image" @error="s.profileImage = null">
                                  <template v-slot:placeholder>
                                      <v-icon size="50" color="blue-grey lighten-5">mdi-account-circle</v-icon>
                                      <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                                  </template>
                              </v-img>
                              <v-icon v-else size="50" color="blue-grey lighten-4">mdi-account-circle</v-icon>
                          </v-avatar>
                          <span class="c-name ellipsis" :title="s.name">{{ s.name }}<br>
                          <span :title="s.mobile" class="f-12 grey--text text--darken-1">{{s.mobile}}</span>
                          </span>
                      </td>
                      <td>{{s.Orders_aggregate.aggregate.count}}</td>
                      <td>{{s.OrderItems_aggregate.aggregate.sum.qty}}</td>
                      <td>{{Number(s.Orders_aggregate.aggregate.sum.payableAmount) | currencyFilter}}</td>
                  </tr>
              </template>
              <tr style="color: teal; font-weight: bolder" v-show="items.length">         <!-- table summary -->
                  <td style="font-size: 18px">SUMMARY</td>
                  <td style="font-size: 18px">{{bodyAppendRow.count}}</td>
                  <td style="font-size: 18px">{{bodyAppendRow.qty}}</td>
                  <td style="font-size: 18px">{{bodyAppendRow.totalAmount | currencyFilter}}</td>
              </tr>
              </tbody>
          </template>
      </v-data-table>

      <gallery id="gallery-sales-exec-report" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
  </div>
</template>

<script>
import Constants from "../../Constants/Constants";
import {GET_SALES_EXECUTIVE_AS_SUMMARY, GET_SALES_EXECUTIVE_WITH_CUSTOMER_SUMMARY} from "../../graphql/queries/Users";
import {users_summary_aggregate, users_summary_statement} from "../../graphql/customStatement";
import moment from 'moment';
import Vue from "vue";

export default {
    name: "SalesExecutiveReport",
    apollo: {},
    data(){
        return{
            Constants: Constants,
            user: JSON.parse(localStorage.user),
            moment: moment,
            reportData: [],
            date: {startDate: moment(), endDate: moment()},
            headers: [
              { text: 'Sales Executive', value: 'name'}, { text: 'Orders Count', value: 'aggregate.count'},
              { text: 'Quantity', value: 'aggregate.sum.totalQty'}, { text: 'Total Amount', value: 'aggregate.sum.payableAmount' },
            ],
            showGroupData: false,
            tempShowGroupData: false,
            bodyAppendRow: { count:0, qty:0, totalAmount:0 },               //table summary row
            loading: false,
            search: '',
            galleryImages: [],
            galleryIndex: null,
        }
    },
    computed:{
        disableApplyBtn(){
            return false
        }
    },
    methods:{
        toggleGroupRow(item){
            if(this.showGroupData) Vue.set(item, 'show', !item.show)
        },
        onClearFilter(){
            this.reportData = []
        },
        async getSalesReport(){
            this.loading = true
            let startDate = moment(this.date.startDate).format('YYYY-MM-DDT00:00:00+05:30')
            let endDate = moment(this.date.endDate).format('YYYY-MM-DDT23:59:59+05:30')

            if(this.tempShowGroupData) await this.getSalesExecWithCustomerSummary(startDate, endDate)
            else await this.getSalesExecSummary(startDate, endDate)

            this.bodyAppendRow = {count: 0, qty:0, totalAmount: 0};
            this.reportData.forEach(g => {
                this.bodyAppendRow.count += Number(g.aggregate.count)
                this.bodyAppendRow.qty += Number(g.aggregate.sum.totalQty)
                this.bodyAppendRow.totalAmount += Number(g.aggregate.sum.payableAmount)
            })
            this.search = ''
            this.showGroupData = this.tempShowGroupData
            this.loading = false
        },
        async getSalesExecSummary(startDate, endDate){
            let response = await this.$apollo.query({
                query: GET_SALES_EXECUTIVE_AS_SUMMARY,
                fetchPolicy: 'network-only',
                variables: {
                    statement: users_summary_statement(startDate, endDate),
                    aggregate: users_summary_aggregate
                }
            })
            if(response.data) this.reportData = response.data.salesExecSummary
        },
        async getSalesExecWithCustomerSummary(startDate, endDate){
            let response = await this.$apollo.query({
                query: GET_SALES_EXECUTIVE_WITH_CUSTOMER_SUMMARY,
                fetchPolicy: 'network-only',
                variables: {
                    statement: users_summary_statement(startDate, endDate),
                    aggregate: users_summary_aggregate,
                    startDate, endDate
                }
            })
            if(response.data) this.reportData = response.data.salesExecWithCustomerSummary
        },
        filterItems(value, search, item) {
            search = search.toLowerCase()
            return (item.name?.toLowerCase().indexOf(search) > -1)||
                (item.mobile?.indexOf(search) > -1)||
                (item.Customers&&this.filterByNestedCustomers(search, item.Customers));
        },
        filterByNestedCustomers(search, customers){
            for(let i=0; i<customers.length; i++){
                if((customers[i].name?.toLowerCase().indexOf(search) > -1)||
                    (customers[i].mobile?.indexOf(search) > -1)) return true
            }
        },
        openGallery(arr){
            this.galleryImages = arr.map(m => {return {
                href: this.imgWpx(m.path, 900, m.type),
                type: m.type.toLowerCase() + '/' + m.path.split('.').pop()
            }})
            this.galleryIndex = 0
        }
    }
}
</script>

<style scoped>
  #salesExecutiveReport {
    padding: 20px;
  }
  .operation-div{
      display: inline-flex;
      float: right;
      font-size: 16px;
      font-weight: 600;
      color: #c0c0c0;
      height: 16px;
      margin-top: -20px;
      cursor: pointer;
  }
  /deep/ .operation-switch.v-input--switch .v-input--switch__track{
      color: #4caf50;
  }
  /deep/ .operation-switch.v-input--switch .v-input--switch__thumb{
      color: #4caf50;
  }
  .ellipsis{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: default;
  }
  .c-name{
      display: inline-block;
      vertical-align: middle;
      width: 150px;
      max-width: 150px;
  }
</style>